import styled from "styled-components";

import { theme } from "theme/theme";
import { Table, Button, Modal, Select } from "components";

export const TaskWrapperRight = styled.div`
  button {
    display: none;
  }
  ${theme.media.tablet} {
    button {
      display: unset;
    }
    > svg {
      display: none;
    }
  }
`;

export const PaginationWrapper = styled.div`
  margin-bottom: 16px;
  text-align: center;
  ${theme.media.tablet} {
    display: flex;
    justify-content: end;
    text-align: unset;
  }
`;

export const ContentWrapper = styled.div`
  /* margin-bottom: 32px; */
`;

export const SearchWrapper = styled.div`
  ${theme.media.tablet} {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
  }
`;

export const WrapperSelectAndBtn = styled.div`
  display: flex;
  ${theme.media.mobileM} {
    justify-content: space-between;
    .ant-select {
      width: 231px;
    }
    .ant-select-selector {
      width: 231px;
    }
  }
  ${theme.media.mobileL} {
    justify-content: initial;
    .ant-select {
      margin-right: 16px;
    }
  }
  ${theme.media.tablet} {
    .ant-select {
      width: 170px;
    }
    .ant-select-selector {
      width: 170px;
    }
    button {
      height: 31px;
    }
  }
  ${theme.media.laptop} {
    .ant-select {
      width: 175px;
      margin-right: 16px;
    }
    .ant-select-selector {
      width: 175px;
    }
  }
`;

export const RowCellWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 17px;
  svg {
    cursor: pointer;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  .ant-select-selector {
    background-color: #ffffff !important;
  }
`;

export const TableStyled = styled(Table)`
  .ant-table-thead tr th:first-child,
  .ant-table-thead tr th:nth-child(2) {
    padding-left: 16px;
  }
  .ant-table-tbody tr td:first-child,
  .ant-table-tbody tr td:nth-child(2) {
    padding-left: 16px;
  }
  .ant-table-thead tr th:last-child {
    text-align: right;
  }
  .ant-table-tbody tr td:last-child {
    text-align: right;
  }
  .ant-table-tbody tr td {
    vertical-align: top;
    font-size: 14px;
    line-height: 20px;
  }
  .ant-table-thead > tr > th:not(:first-child) {
    &:before {
      height: 38px !important;
    }
  }
`;

export const TaskWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: flex-end;
  background: #f2f2f2;
  border-radius: 8px 8px 0px 0px;
`;

export const WrapperAction = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${theme.media.tablet} {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`;

export const WrapperInputAndBtn = styled.div`
  input {
    width: 100%;
    margin-bottom: 8px;
  }
  ${theme.media.tablet} {
    display: flex;
    input {
      width: 215px;
      margin-right: 16px;
      margin-bottom: 0;
    }
  }
  ${theme.media.laptopL} {
    input {
      width: 292px;
    }
  }
`;

export const UserDetailTitle = styled.div<{ width: string }>`
  background: ${theme.colors.background};
  border-radius: 4px;
  padding: 7px;
  font-size: ${theme.sizes.md};
  font-weight: ${theme.fontWeight.medium};
  line-height: 16px;
  width: ${(props) => props.width};
`;

export const ModalUserDetail = styled(Modal)`
  .ant-modal-header {
    padding: 16px;
  }
  .ant-modal-close {
    top: 8px;
  }
  .ant-modal-body {
    height: max-content;
    overflow: auto;
    padding: 16px;
    min-height: 494px;
    max-height: 974px;

    > div {
      margin-bottom: 16px;
    }
    > div:last-child {
      margin-bottom: unset;
    }
    &::-webkit-scrollbar {
      width: 16px;
    }
    &::-webkit-scrollbar-track {
      margin: 8px 0px 8px;
      border-left: 4px solid ${theme.colors.white};
      border-right: 4px solid ${theme.colors.white};
      background: ${theme.colors.background};
      border-radius: 7px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bdbdbd;
      border-radius: 7px;
      border-left: 4px solid ${theme.colors.white};
      border-right: 4px solid ${theme.colors.white};
    }
  }
`;

export const Information = styled.div`
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  padding: 7px 15px 15px;
  min-height: 462px;
`;

export const InformationTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.border};
  padding-bottom: 7px;
  position: relative;
  .dot {
    position: absolute;
    top: 0;
    left: -8px;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: #fb4e4e;
  }
  div {
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.sizes.md};
    line-height: 24px;
    color: ${theme.colors.titleText};
  }
`;

export const InformationContent = styled.div`
  display: flex;
  gap: 16px;
`;

export const InformationContentLeft = styled.div`
  flex: 1;
  > div:last-child {
    border-bottom: unset;
  }
  > div:nth-child(5) {
    min-height: 87px;
  }
`;

export const InformationContentRight = styled.div`
  flex: 1;
  > div {
    padding-top: 8px;
    font-size: ${theme.sizes.md};
    line-height: 24px;
    margin-bottom: 4px;
    font-weight: ${theme.fontWeight.regular};
  }
`;

export const InformationGroup = styled.div`
  padding: 8px 0 7px;
  border-bottom: 1px solid ${theme.colors.border};
  div {
    font-size: ${theme.sizes.md};
    line-height: 24px;
  }
  div:first-child {
    font-weight: ${theme.fontWeight.regular};
  }
  div:nth-child(2) {
    font-weight: ${theme.fontWeight.bold};
  }
  span {
    font-weight: 400;
  }
`;

export const Questionaire = styled.div`
  border-radius: 8px;
  background: ${theme.colors.background};
  padding: 8px 2px 8px 8px;
  width: 100%;
  height: 370px;
  overflow: auto;
  margin-bottom: 0px !important;
  > div:last-child {
    margin-bottom: 0px;
  }
  &::-webkit-scrollbar {
    width: 16px;
  }
  &::-webkit-scrollbar-track {
    margin: 8px 0px 8px;
    border-left: 4px solid ${theme.colors.background};
    border-right: 4px solid ${theme.colors.background};
    background: ${theme.colors.background};
    border-radius: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 7px;
    border-left: 4px solid ${theme.colors.background};
    border-right: 4px solid ${theme.colors.background};
  }
`;

export const Question = styled.div`
  border-radius: 4px;
  background: ${theme.colors.white};
  padding: 0 8px;
  margin-bottom: 8px;
  div {
    font-size: ${theme.sizes.sm};
    line-height: 18px;
  }
`;

export const QuestionName = styled.div`
  padding: 4px 0;
  font-weight: ${theme.fontWeight.regular};
  border-bottom: 1px dotted ${theme.colors.border};
`;

export const QuestionAnswer = styled.div`
  padding: 4px 0;
  font-weight: ${theme.fontWeight.bold};
`;

export const QuestionAnswer2 = styled.div`
  padding: 4px 0;
  span {
    font-weight: ${theme.fontWeight.bold};
  }
`;

export const DiagnosisAnswer = styled.div`
  div:first-child {
    font-weight: ${theme.fontWeight.bold};
    font-size: 16px;
    line-height: 24px;
  }
  div,
  div:nth-child(2) {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
`;
